"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubscribeInfo = exports.getAuthorDetail = void 0;
var config = require("../../../config/web");
/**
 * 获取author信息
 * @param authorId
 * @returns
 */
function getAuthorDetail(authorId) {
    return __awaiter(this, void 0, void 0, function () {
        var json, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(config.getWebPath('cfh'), "Author/GetAuthorDetail?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: {
                                authorId: authorId
                            }
                        })];
                case 1:
                    json = _a.sent();
                    if (json && (json === null || json === void 0 ? void 0 : json.Result)) {
                        return [2 /*return*/, json.Result];
                    }
                    return [2 /*return*/, null];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getAuthorDetail = getAuthorDetail;
/**
 * 获取订阅状态
 * @param ids
 * @param type  1：财富号作者 2：财富号话题 =>  type=1:传财富号作者id， type=2：传话题id 多个id按逗号分隔
 * @returns
 */
function getSubscribeInfo(ids, type) {
    return __awaiter(this, void 0, void 0, function () {
        var json, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(config.getWebPath('cfh'), "subscribe/IsSubscribe?callback=?"),
                            type: 'GET',
                            data: {
                                type: type,
                                ids: ids,
                                businessid: Math.random()
                            },
                            dataType: 'jsonp'
                        })];
                case 1:
                    json = _a.sent();
                    if (json && (json === null || json === void 0 ? void 0 : json.Result)) {
                        return [2 /*return*/, json.Result];
                    }
                    return [2 /*return*/, null];
                case 2:
                    error_2 = _a.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getSubscribeInfo = getSubscribeInfo;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2ViX2NmaC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIndlYl9jZmgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsSUFBSSxNQUFNLEdBQUcsT0FBTyxDQUFDLHFCQUFxQixDQUFDLENBQUE7QUFHM0M7Ozs7R0FJRztBQUNILFNBQXNCLGVBQWUsQ0FBQyxRQUFnQjs7Ozs7OztvQkFHdkMscUJBQU0sQ0FBQyxDQUFDLElBQUksQ0FBQzs0QkFDdEIsR0FBRyxFQUFFLFVBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsc0NBQW1DOzRCQUNuRSxJQUFJLEVBQUUsS0FBSzs0QkFDWCxRQUFRLEVBQUUsT0FBTzs0QkFDakIsSUFBSSxFQUFFO2dDQUNKLFFBQVEsRUFBRSxRQUFROzZCQUNuQjt5QkFDRixDQUFDLEVBQUE7O29CQVBFLElBQUksR0FBRyxTQU9UO29CQUVGLElBQUksSUFBSSxLQUFJLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxNQUFNLENBQUEsRUFBRTt3QkFDeEIsc0JBQU8sSUFBSSxDQUFDLE1BQU0sRUFBQTtxQkFDbkI7b0JBRUQsc0JBQU8sSUFBSSxFQUFBOzs7b0JBRVgsc0JBQU8sSUFBSSxFQUFBOzs7OztDQUVkO0FBcEJELDBDQW9CQztBQUVEOzs7OztHQUtHO0FBQ0gsU0FBc0IsZ0JBQWdCLENBQUMsR0FBVyxFQUFFLElBQVk7Ozs7Ozs7b0JBR2pELHFCQUFNLENBQUMsQ0FBQyxJQUFJLENBQUM7NEJBQ3RCLEdBQUcsRUFBRSxVQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLHFDQUFrQzs0QkFDbEUsSUFBSSxFQUFFLEtBQUs7NEJBQ1gsSUFBSSxFQUFFO2dDQUNKLElBQUksTUFBQTtnQ0FDSixHQUFHLEtBQUE7Z0NBQ0gsVUFBVSxFQUFFLElBQUksQ0FBQyxNQUFNLEVBQUU7NkJBQzFCOzRCQUNELFFBQVEsRUFBRSxPQUFPO3lCQUNsQixDQUFDLEVBQUE7O29CQVRFLElBQUksR0FBRyxTQVNUO29CQUVGLElBQUksSUFBSSxLQUFJLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxNQUFNLENBQUEsRUFBRTt3QkFDeEIsc0JBQU8sSUFBSSxDQUFDLE1BQU0sRUFBQTtxQkFDbkI7b0JBRUQsc0JBQU8sSUFBSSxFQUFBOzs7b0JBRVgsc0JBQU8sSUFBSSxFQUFBOzs7OztDQUVkO0FBdEJELDRDQXNCQyJ9